import React, { Fragment, useState, useEffect } from "react";
import {
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
} from "reactstrap";
import { Btn, H5, UL, LI, H6 } from "../../../AbstractElements";
import {
  EmailAddress,
  LoginWithJWT,
  Password,
  SignIn,
} from "../../../Constant";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { firebase_app, Jwt_token } from "../../../Config/Config";
import man from "../../../assets/images/dashboard/1.png";
import { handleResponse } from "../../../Services/Fack.Backend";
import FormHeader from "./FormHeader";
import FormPassword from "./FormPassword";
import SignInWith from "./SignInWith";
import { Phone, Lock } from "react-feather";
import axios from "axios";
import Language from "../../../Layout/Header/Langauge";

const LoginTab = ({ selected }) => {
  const lang = localStorage?.getItem('i18nextLng');
  const [phone_number, setPhoneNumber] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const [togglePassword, setTogglePassword] = useState(false);
  const history = useNavigate();

  const [value, setValue] = useState(localStorage.getItem("profileURL" || man));
  const [name, setName] = useState(localStorage.getItem("Name"));

  useEffect(() => {
    localStorage.setItem("profileURL", value);
    localStorage.setItem("Name", name);
  }, [value, name]);

  const loginAuth = async (e) => {
    e.preventDefault();
    setLoading(true);
    setValue(man);
    setName("Emay Walter");
    setPhoneNumber("test@gmail.com");
    setPassword("test123");
    try {
      await firebase_app
        .auth()
        .signInWithEmailAndPassword(phone_number, password)
        .then(function () {
          setValue(man);
          setName("Emay Walter");
          setTimeout(() => {
            history(`${process.env.PUBLIC_URL}/dashboard/default`);
          }, 200);
        });
    } catch (error) {
      setTimeout(() => {
        toast.error(
          "Oppss.. The password is invalid or the user does not have a password."
        );
      }, 200);
    }
  };
  const loginWithJwt = async (e) => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: { phone_number, password },
    };

    return fetch("/users/authenticate", requestOptions)
      .then(handleResponse)
      .then((user) => {
        setValue(man);
        setName("Emay Walter");
        localStorage.setItem("token", Jwt_token);
        window.location.href = `${process.env.PUBLIC_URL}/dashboard/default/`;
        return user;
      });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response2 = await axios.post(
        "https://api-portal.nada.org.np/api/users/login",
        {
          phone_number: phone_number,
          password: password,
          admin_req: true,
        }
      );

      if (response2?.data?.success) {
        localStorage.setItem("token", response2?.data?.data?.token);
        localStorage.setItem("currentUser", response2?.data?.data?.phone_number);
        localStorage.setItem("authenticated", "true");
        const name = response2?.data?.data?.name ? response2?.data?.data?.name : 'null';
        const image = response2?.data?.data?.profile_pic ? response2?.data?.data?.profile_pic : 'null';
        const position = response2?.data?.data?.position ? response2?.data?.data?.position : 'null';
        localStorage.setItem("image", image);
        localStorage.setItem("position", position);
        localStorage.setItem("Name", name);
        const press = response2?.data?.data?.pres === true? 'true' : 'false'
        localStorage.setItem("pres",  press);
        window.location.href = `${process.env.PUBLIC_URL}/dashboard`;
      } else {
        toast.error(response2?.data?.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
      if (error.response) {
      } else if (error.request) {
        console.error("Error request:", error.request);
      } else {
        console.error("Error message:", error.message);
      }
    }
  };

  return (
    <Fragment>
      <Form className="theme-form login-form">
        <FormHeader selected={selected} />
        <FormGroup>
          <Label>{t("Phone Number")}</Label>
          <InputGroup>
            <InputGroupText>
              <Phone />
            </InputGroupText>
            <Input
              className="form-control"
              type="number"
              required=""
              onChange={(e) => setPhoneNumber(e.target.value)}
              placeholder="Enter the phone number"
              value={phone_number}
            />
          </InputGroup>
        </FormGroup>
        <FormGroup>
          <Label>{t("Password")}</Label>
          <InputGroup>
            <InputGroupText>
              <Lock />
            </InputGroupText>
            <Input
              className="form-control"
              type={togglePassword ? "text" : "password"}
              onChange={(e) => setPassword(e.target.value)}
              value={password}
              required=""
              placeholder="********"
            />
            <div
              className="show-hide"
              onClick={() => setTogglePassword(!togglePassword)}
            >
              <span className={togglePassword ? "" : "show"}></span>
            </div>
          </InputGroup>
        </FormGroup>
        {/*<FormPassword t={t} />*/}
        <FormGroup>
            <Btn
              attrBtn={{
                color: "primary",
                className: "btn-block",
                disabled: loading ? loading : loading,
                onClick: (e) => handleLogin(e),
              }}
            >
              {loading ? "LOADING..." : t("Sign In")}
            </Btn>
        </FormGroup>
        {<SignInWith t={t} />}
        <div style={{ position: 'absolute', top: 1, right: -60, backgroundColor: '#fff', width: 50, height: 40, alignItems: 'center', display: 'flex', justifyContent:'center', borderRadius: '8px' }}>
        <UL attrUL={{ className: `simple-list flex-row nav-menus` }}>
        <LI attrLI={{ className: 'onhover-dropdown' }}><H6 attrH6={{ className: 'txt-dark mb-0 mt-1' }}>{lang === 'es'? 'NP' : 'EN'}</H6>
            <Language />
          </LI>
          </UL>
        </div>
      </Form>
    </Fragment>
  );
};

export default LoginTab;
